import { HashRouter, Routes, Route } from 'react-router-dom';
import { ROUTES } from '@/lib/index';
import Layout from '@/components/Layout';
import Home from '@/pages/Home';
import Catalog from '@/pages/Catalog';
import Order from '@/pages/Order';
import Clients from '@/pages/Clients';
import Pricing from '@/pages/Pricing';
import Admin from '@/pages/Admin';

export default function App() {
  return (
    <div className="dark">
      <HashRouter>
        <Routes>
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={
            <Layout>
              <Routes>
                <Route path={ROUTES.HOME} element={<Home />} />
                <Route path={ROUTES.CATALOG} element={<Catalog />} />
                <Route path={ROUTES.ORDER} element={<Order />} />
                <Route path={ROUTES.CLIENTS} element={<Clients />} />
                <Route path={ROUTES.PRICING} element={<Pricing />} />
              </Routes>
            </Layout>
          } />
        </Routes>
      </HashRouter>
    </div>
  );
}
